const REPORT_WIDTH = 32;
const REPORT_HEIGHT = 36;
const reportHeightGridUnits = REPORT_HEIGHT / 2;
export const IMAGE_WIDTH: number = 8 * REPORT_WIDTH;
export const IMAGE_HEIGHT: number = 8 * reportHeightGridUnits;

export const CYCLE_TIME_REPORT_KEY = 'jsw.report.cycle-time';
export const CI_CD_GET_STARTED_LINK =
	'https://www.atlassian.com/software/jira/guides/developers/ci-cd#get-started';
